import React from "react";
import { ArrowRight, CheckCircle2, MessageCircle, Phone } from "lucide-react";

export default function DashboardRecommendationSection({
  GlassCard,
  longPressHandlers,
  handleWidgetClick,
  isMobile,
  sectionHeight,
  radarRecommendations,
  isEditMode,
  setSelectedRecommendation,
  handleDismissRadar,
  icons,
}) {
  return (
    <GlassCard
      {...longPressHandlers}
      onClick={handleWidgetClick}
      variant={isMobile ? "solid" : "glass"}
      isMobile={isMobile}
      className={`p-6 flex flex-col h-full min-h-[180px] bg-gradient-to-br from-white to-orange-50/30 ${isMobile ? "!rounded-[20px] bg-white" : "border-b-[8px] border-orange-500 shadow-xl shadow-orange-500/20"}`}
      noHover
    >
      <div className="flex justify-between items-center mb-6 relative z-10 shrink-0">
        <div>
          <h4 className="font-bold text-[#2C3E30] flex items-center gap-2 text-lg font-do-hyeon">
            <img src={icons.sparkles} alt="sparkles" className="w-8 h-8 drop-shadow-md" /> 오늘의 목양 추천
          </h4>
          {sectionHeight > 1 && <p className="text-xs font-bold text-gray-400 mt-1 ml-1">오늘 이 아이들을 챙겨주세요!</p>}
        </div>
        <span className="text-xs font-bold text-white bg-orange-400 px-2 py-1 rounded-lg shadow-sm">{radarRecommendations.length}명</span>
      </div>

      <div className="space-y-3 flex-1 overflow-y-auto custom-scrollbar pr-1 relative z-10">
        {radarRecommendations.length === 0 && <div className="text-center py-10 text-gray-400 text-sm font-bold">추천할 항목이 없습니다.</div>}
        {radarRecommendations.map((item) => (
          <div
            key={item.id}
            onClick={() => {
              if (isEditMode) return;
              setSelectedRecommendation(item);
            }}
            className="bg-white/60 backdrop-blur-sm p-4 rounded-2xl border border-white/50 shadow-sm hover:shadow-md hover:bg-white/90 transition-all group cursor-pointer flex items-center gap-4"
          >
            <div className={`w-14 h-14 rounded-full flex items-center justify-center shadow-sm border border-white/50 ${item.color.replace("text-", "bg-").split(" ")[0]} bg-opacity-20`}>
              <img src={item.icon} alt="icon" className="w-8 h-8 drop-shadow-sm" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center flex-wrap gap-2 mb-1">
                <h5 className="font-black text-gray-800 text-sm leading-none whitespace-nowrap">{item.name}</h5>
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-md ${item.color} flex items-center gap-1 leading-none whitespace-nowrap`}>
                  {item.id.startsWith("new") ? (
                    <>
                      새가족 <img src={icons.seedling} alt="seedling" className="w-3 h-3 object-contain" />
                    </>
                  ) : (
                    item.reason
                  )}
                </span>
              </div>
              <p className="text-xs text-gray-500 font-bold flex items-center gap-1">
                <ArrowRight size={10} /> {item.action}
              </p>
            </div>
            <button
              className={`p-2 rounded-xl text-white shadow-sm hover:scale-110 transition-transform ${item.btnColor}`}
              onClick={(e) => {
                e.stopPropagation();
                handleDismissRadar(item.id, item.action);
              }}
            >
              {item.btnText === "전화" ? <Phone size={16} /> : item.btnText === "축하" ? <MessageCircle size={16} /> : <CheckCircle2 size={16} />}
            </button>
          </div>
        ))}
      </div>
    </GlassCard>
  );
}
